import React from "react";
import { useNavigate } from "react-router-dom"; // Import navigate hook
import "../css/vehicle.css";

import Sedan from "../assets/transport/sedan.webp"
import Ertiga from "../assets/transport/ertiga.webp"
import Crysta from "../assets/transport/crysta.webp"
import TempoTraveller from "../assets/transport/tempo-traveller.webp"
import RailwayStationPickup from "../assets/transport/railway-pickup-drop.avif"
import AirportPickup from "../assets/transport/airport-pickup-drop.jpg"
import Sightseeing from "../assets/transport/local-sightseeing.avif"
import Intercity from "../assets/transport/intercity-transfers.avif"

const Vehicle = () => {
    const navigate = useNavigate();

    // Define vehicle data correctly
    const vehicles = [
        { image: Sedan, name: "Sedan" },
        { image: Ertiga, name: "Ertiga" },
        { image: Crysta, name: "Crysta" },
        { image: TempoTraveller, name: "Tempo Traveller" },
        { image: RailwayStationPickup, name: "Station Pickup & Drop" },
        { image: AirportPickup, name: "Airport Pickup & Drop" },
        { image: Sightseeing, name: "Local Sight Seeing" },
        { image: Intercity, name: "Intercity Transfers" },
    ];

    return (
        <div className="transport-booking">
            <h1>Vehicle Booking</h1>
            <div className="transport-booking-container">
                {vehicles.map((vehicle, index) => (
                    <div
                        key={index}
                        className={`transport-booking-box transport-booking-box${index + 1}`}
                        onClick={() => navigate(`/vehicles/${vehicle.name.toLowerCase().replace(/\s+/g, "-")}`)}
                    >
                        <img src={vehicle.image} alt={vehicle.name} className="vehicle-image" />
                        <div className="transport-booking-box-content">
                            <h2>{vehicle.name}</h2>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Vehicle;
